import { EventEmitter, Output, Directive, Input } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  ValidationErrors,
  Validator,
  ValidatorFn
} from '@angular/forms';
import { NK_FORMATTER, NK_PARSER } from '@nitro/core/common';

@Directive()
export abstract class NkPickerControl<V> implements ControlValueAccessor, Validator {
  /* optional function to parse a value into a known type */
  parser: NK_PARSER<V> | null = null;
  /* optional function to format a value into a string */
  formatter: NK_FORMATTER<V> | null = null;

  validator: ValidatorFn | null = null;
  _validationErrors: ValidationErrors | null;

  _value: V | null;
  get value(): V | null {
    return this._value;
  }

  set value(value: V | null) {
    if (value !== undefined && this._value !== value) {
      this._value = value;
      this._onChange(value);
      this._onTouched(value);
    }
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  _disabled: boolean = false;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  @Input()
  get disabled(): boolean {
    return this._disabled;
  }

  set disabled(d: boolean) {
    this._disabled = d;
  }

  @Output() readonly valueChange: EventEmitter<V> = new EventEmitter<V>();
  @Output() readonly userSelection: EventEmitter<V> = new EventEmitter<V>();
  @Output()
  readonly validStateChange: EventEmitter<ValidationErrors | null> = new EventEmitter<ValidationErrors | null>();

  _onValidatorChange: () => void = () => {
    this.validStateChange.emit(this._validationErrors);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _onTouched: any = () => {};

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _onChange: any = () => {};

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _onUserInput(ev: any) {
    this.userSelection.emit(ev);
    this._onChange(ev);
    this._onTouched();
  }

  updateControls: (_: V) => void = () => {};

  writeValue(value: V): void {
    this.value = value;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: (value: any) => void): void {
    this._onChange = fn;
  }

  registerOnValidatorChange(fn: () => void): void {
    this._onValidatorChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(c: AbstractControl): ValidationErrors | null {
    this._validationErrors = this.validator ? this.validator(c) : null;
    return this._validationErrors;
  }
}
